var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicTemplatePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Clinic_Templates_Purple"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clinic_Templates_Purple",
    "data-name": "Clinic Templates Purple",
    clipPath: "url(#clip-Clinic_Templates_Purple)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3690",
    "data-name": "Group 3690",
    transform: "translate(-571.855 -1500.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5958",
    "data-name": "Path 5958",
    d: "M609.505,1501.606v-.054a.893.893,0,1,0-1.786,0v.054",
    transform: "translate(-28.643)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5959",
    "data-name": "Path 5959",
    d: "M600.537,1507.7v1.882a.322.322,0,0,0,.322.322h.129a.322.322,0,0,0,.319-.28l.005-.04a1.127,1.127,0,0,1,2.236,0l.005.04a.322.322,0,0,0,.641-.042V1507.7a.249.249,0,0,0-.249-.249h-3.16a.249.249,0,0,0-.249.249",
    transform: "translate(-22.461 -5.848)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5960",
    "data-name": "Path 5960",
    d: "M578.076,1512.859H575.31a.871.871,0,0,0-.871.871v13.363a.871.871,0,0,0,.871.872h9.317a.872.872,0,0,0,.872-.872V1513.73a.871.871,0,0,0-.872-.871h-2.894",
    transform: "translate(0 -10.5)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5961",
    "data-name": "Path 5961",
    d: "M585.75,1522.125h-2.044v12.524h6.565l1.913-1.913v-10.61h-2.044",
    transform: "translate(-7.975 -18.474)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5962",
    "data-name": "Path 5962",
    d: "M597.639,1560.389l-1.024,1.085-.5-.5",
    transform: "translate(-18.659 -51.407)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_630",
    "data-name": "Line 630",
    y1: 1.221,
    x2: 1.221,
    transform: "translate(577.511 1505.829)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_631",
    "data-name": "Line 631",
    x1: 1.221,
    y1: 1.221,
    transform: "translate(577.511 1505.829)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_632",
    "data-name": "Line 632",
    y1: 1.221,
    x2: 1.221,
    transform: "translate(577.511 1512.121)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_633",
    "data-name": "Line 633",
    x1: 1.221,
    y1: 1.221,
    transform: "translate(577.511 1512.121)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_634",
    "data-name": "Line 634",
    x2: 3.534,
    transform: "translate(579.603 1507.05)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_635",
    "data-name": "Line 635",
    x2: 3.534,
    transform: "translate(579.603 1510.139)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5963",
    "data-name": "Path 5963",
    d: "M627.887,1596.882v-1.545h1.544",
    transform: "translate(-46 -81.485)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicTemplatePurple);
export default __webpack_public_path__ + "static/media/clinic-template-purple.c26d589c8d4e6a15a0dfa29f54d15857.svg";
export { ForwardRef as ReactComponent };